import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import VirtualExperiencesForm from './VirtualExperiencesForm'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'

const VirtualExperienceCreate: React.FC = () => (
  <SectionWrapper>
    <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
      <VirtualExperiencesForm />
    </Create>
  </SectionWrapper>
)

export default VirtualExperienceCreate
